import MyBtn from './MyBtn'
import './MyBtn.scss'

export default MyBtn
